var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-page"},[_c('div',{staticClass:"page-wrap"},[_c('s-load-fonts'),_c('div',{staticClass:"page-container"},[_c('router-view'),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }